import { createStaffTeamApi } from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { TeamRuntime } from "./runtime";

/** The runtime of the real admin app: the typed client over `fetch` and the clock. The bearer token comes from the shared function. */
export function createAdminTeamRuntime(): TeamRuntime {
  const config = getAdminPublicConfig();
  return {
    api: createStaffTeamApi({
      baseUrl: config.apiUrl.toString(),
      getAccessToken: currentAccessToken,
    }),
    now: () => new Date(),
  };
}
